export default {
  'table.columnsSetting': '列设置',
  'table.fixedLeft':'固定在左侧',
  'table.fixedRight':'固定在右侧',
  'table.unpan': '取消固定',
  'table.export': '导出',
  'table.operation': '操作',
};
